import {createSlice} from "@reduxjs/toolkit";

export const appSlice = createSlice({
  name: 'app',
  initialState: {
    // 右侧菜单项可见性
    editVisible: false,//编辑区
    treeVisible: false,//对象树
    skyVisible: false,//天空
    sceneVisible: false,//场景
    viewVisible: false,//视图
    vrVisible: false,//VR设置
    measureVisible: false,//测量
    createModelVisible: false,//创建模型

    // 右侧菜单 数据
    treeList: [],//对象树
    activeTreeNodeId: [],//对象树选中的树节点
    measureList: [],//测量
    unit: 'm',//测量单位
    mVisible: true,//测量全部可见
    skyInfo: { //天空数据
      sunAngle: 0, weather: 'sun', ambientIntensity: 0, ambientColor: '#FFFFFF', fogDensity: 0, fogColor: '#FFFFFF'
    },
    activeView: 'default',//当前选中视图
    vrData: {//VR数据
      enabled: false, floor_enabled: false, floor_color: '#FFFFFF', position_enabled: false
    },
    activeModelIndex: 0,//创建模型

    // 底部菜单
    editType: '',//底部菜单编辑类型
    sceneModelInfo: {//场景模型-基本数据
      name: '现代多层办公楼',
      position: {x: 0, y: 0, z: 0},
      rotation: {x: 0, y: 0, z: 0},
      scale: {x: 1, y: 1, z: 1},
      isSelect: false
    },
    sceneModelSetting: {// 模型场景 设置
      row: 1, column: 1, gap: 1
    },
    locked: false,//场景模型-缩放-锁
    materialInfo: {//材质
      image: '/defaultMat.jpg', name: '', color: '#FFFFFF', scale: 1, direction: 0, isSelect: false
    },
    materialName: '',//搜索的材质名称
    materialList: [],//材质库
    modelInfo: {//模型
      name: '', image: '/defaultMat.jpg', isSelect: false
    },
    modelSetting: {//模型设置
      type: 'matrix',//matrix curve 矩阵 曲线
      gap: 1, row: 1, column: 1, lineType: 'curve',//line curve 直线 曲线
      random: false
    },
    modelArrange: 'matrix',//模型排列 matrix curve
    modelType: {label: '曲线', value: 'curve'},//模型线类型
    modelAccuracy: {value: 'middle', label: '中'},//模型精度
    modelName: '',//搜索的模型名称
    modelList: []//模型库
  },
  reducers: {
    setEditVisible(state, action) {
      state.editVisible = action.payload
    },
    setTreeVisible(state, action) {
      state.treeVisible = action.payload
    },
    setSkyVisible(state, action) {
      state.skyVisible = action.payload
    },
    setSceneVisible(state, action) {
      state.sceneVisible = action.payload
    },
    setViewVisible(state, action) {
      state.viewVisible = action.payload
    },
    setVrVisible(state, action) {
      state.vrVisible = action.payload
    },
    setMeasureVisible(state, action) {
      state.measureVisible = action.payload
    },
    setCreateModelVisible(state, action) {
      state.createModelVisible = action.payload
    },
    setTreeList(state, action) {
      state.treeList = [...action.payload]
    },
    setActiveTreeNodeId(state, action) {
      console.log(action.payload)
      state.activeTreeNodeId = action.payload
    },
    setMeasureList(state, action) {
      state.measureList = [...action.payload]
    },
    setUnit(state, action) {
      state.unit = action.payload
    },
    setMVisible(state, action) {
      state.mVisible = action.payload
    },
    setSkyInfo(state, action) {
      const payload = typeof action.payload === 'function'
        ? action.payload(state.skyInfo)
        : action.payload;
      state.skyInfo = {...state.skyInfo, ...payload};
    },
    setActiveView(state, action) {
      state.activeView = action.payload
    },
    setVrData(state, action) {
      const payload = typeof action.payload === 'function'
        ? action.payload(state.skyInfo)
        : action.payload;
      state.vrData = {...state.vrData, ...payload}
    },
    setActiveModelIndex(state, action) {
      state.activeModelIndex = action.payload
    },
    setEditType(state, action) {
      state.editType = action.payload
    },
    setSceneModelInfo(state, action) {
      state.sceneModelInfo = action.payload
    },
    setSceneModelSetting(state, action) {
      state.sceneModelSetting = action.payload
    },
    setLocked(state, action) {
      console.log(action.payload)
      state.locked = false
      //state.locked = action.payload
      //state.locked = !state.locked
    },
    setMaterialInfo(state, action) {
      const payload = typeof action.payload === 'function'
        ? action.payload(state.skyInfo)
        : action.payload;
      state.materialInfo = {...state.materialInfo, ...payload}
    },
    setMaterialName(state, action) {
      state.materialName = action.payload
    },
    setMaterialList(state, action) {
      state.materialList = action.payload
    },
    setModelInfo(state, action) {
      state.modelInfo = action.payload
    },
    setModelSetting(state, action) {
      state.modelSetting = action.payload
    },
    setModelArrange(state, action) {
      state.modelArrange = action.payload
    },
    setModelType(state, action) {
      state.modelType = action.payload
    },
    setModelAccuracy(state, action) {
      state.modelAccuracy = action.payload
    },
    setModelName(state, action) {
      state.modelName = action.payload
    },
    setModelList(state, action) {
      state.modelList = action.payload
    }
  }
})

export const {
  setEditVisible,
  setTreeVisible,
  setSkyVisible,
  setSceneVisible,
  setViewVisible,
  setVrVisible,
  setMeasureVisible,
  setCreateModelVisible,

  setEditType,
  setTreeList,
  setActiveTreeNodeId,
  setMeasureList,
  setUnit,
  setMVisible,
  setSkyInfo,
  setActiveView,
  setVrData,
  setActiveModelIndex,

  setSceneModelInfo,
  setSceneModelSetting,
  setLocked,
  setMaterialInfo,
  setMaterialName,
  setMaterialList,
  setModelInfo,
  setModelSetting,
  setModelArrange,
  setModelType,
  setModelAccuracy,
  setModelName,
  setModelList
} = appSlice.actions

export default appSlice.reducer

